import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import BranchSelector from './BranchSelector';

const Navbar = () => {
    const location = useLocation();
    const [scrolled, setScrolled] = useState(false);
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 50);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    // Handle click outside to close menu
    useEffect(() => {
        const handleClickOutside = (event) => {
            const navbar = document.querySelector('.navbar');
            if (isMenuOpen && navbar && !navbar.contains(event.target)) {
                setIsMenuOpen(false);
            }
        };

        if (isMenuOpen) {
            document.addEventListener('click', handleClickOutside);
        }

        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, [isMenuOpen]);

    const handleMenuToggle = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    return (
        <>
            {/* Navbar Start */}
            <div className={`container-fluid fixed-top px-0 ${scrolled ? 'nav-glass' : ''}`}>
                <div className="top-bar row gx-0 align-items-center d-none d-lg-flex">
                    <div className="col-lg-6 px-5 text-start">
                        <BranchSelector variant="header" />
                    </div>
                    <div className="col-lg-6 px-5 text-end">
                        <small><i className="fa fa-envelope text-primary me-2"></i>info@webbears.in</small>
                        <small className="ms-4"><i className="fa fa-clock text-primary me-2"></i>10:00 am - 6:00 pm</small>
                    </div>
                </div>

                <nav className="navbar navbar-expand-lg navbar-light py-lg-0 px-lg-5">
                    <a href="/" className="navbar-brand ms-4 ms-lg-0">
                        <img src="/img/images/tranweb.png" alt="logo" id="BearLogo" />
                    </a>
                    <button 
                        type="button" 
                        className="navbar-toggler me-4" 
                        onClick={handleMenuToggle}
                        aria-expanded={isMenuOpen}
                        aria-label="Toggle navigation"
                    >
                        <span className="navbar-toggler-icon"><i className="fa-solid fa-bars"></i></span>
                    </button>
                    <div className={`collapse navbar-collapse ${isMenuOpen ? 'show' : ''}`} id="navbarCollapse">
                        <div className="d-lg-none px-4 py-3 border-bottom">
                            <BranchSelector variant="header" />
                        </div>
                        <div className="navbar-nav ms-auto p-4 p-lg-0">
                            <a href="/" className={`nav-item nav-link ${location.pathname === '/' ? 'active' : ''}`}>Home</a>
                            <a href="/about" className={`nav-item nav-link ${location.pathname === '/about' ? 'active' : ''}`}>About</a>
                            <a href="/service" className={`nav-item nav-link ${location.pathname === '/service' ? 'active' : ''}`}>Services</a>
                            <div className="nav-item dropdown">
                                <button className={`nav-link dropdown-toggle ${['/project', '/feature', '/testimonial', '/recruitment'].includes(location.pathname) ? 'active' : ''}`} data-bs-toggle="dropdown" style={{border: 'none', background: 'none', cursor: 'pointer', padding: '25px 15px', color: 'var(--tertiary)', fontWeight: 500}}>Pages</button>
                                <div className="dropdown-menu border-light m-0">
                                    <a href="/project" className="dropdown-item">Projects</a>
                                    <a href="/feature" className="dropdown-item">Features</a>
                                    {/* <a href="/team" className="dropdown-item">Team Member</a> */}
                                    <a href="/testimonial" className="dropdown-item">Testimonial</a>
                                    <a href="/recruitment" className="dropdown-item">Recruitment</a>
                                </div>
                            </div>
                            <a href="/contact" className={`nav-item nav-link ${location.pathname === '/contact' ? 'active' : ''}`}>Contact</a>
                        </div>
                        <div className="d-none d-lg-flex ms-2">
                            <a className="btn btn-light btn-sm-square rounded-circle ms-3"
                                href="https://www.facebook.com/profile.php?id=61550026255865">
                                <small className="fab fa-facebook-f text-primary"></small>
                            </a>
                            <a className="btn btn-light btn-sm-square rounded-circle ms-3"
                                href="https://twitter.com/web_bears?t=HuVC18430OfT9jw44urDMw&s=09">
                                <small className="fab fa-twitter text-primary"></small>
                            </a>
                            <a className="btn btn-light btn-sm-square rounded-circle ms-3"
                                href="https://www.linkedin.com/in/web-bears-639b36289/">
                                <small className="fab fa-linkedin-in text-primary"></small>
                            </a>
                            <a className="btn btn-light btn-sm-square rounded-circle ms-3"
                                href="https://www.instagram.com/webbears.in/">
                                <small className="fab fa-instagram text-primary"></small>
                            </a>
                        </div>
                    </div>
                </nav>
            </div>
            {/* Navbar End */}
        </>
    );
};

export default Navbar;
